
export default function UserViewDeleteModalController($scope, $uibModalInstance, user, $state, usersService, gettextCatalog) {

    'ngInject'; 
    
    $scope.user = user;

    $scope.ok = function () {
        usersService.removeUser($scope.user.id).then(function (response) {
            $state.go('admin.userslist');
        }, function (error) {
            var errorMsg = gettextCatalog.getString("An error occurred while removing user information");
            if (error.data || error.status) {
                if (error.data.message) {
                    errorMsg = error.data.message + " " + (error.status.toString() + " - " + error.statusText.toString());
                }
                else {
                    errorMsg += ": " + (error.status.toString() + " - " + error.statusText.toString());
                }
            }
            else {
                errorMsg += gettextCatalog.getString(". Please try again later.");
            }
            $scope.errorText = errorMsg;
            $scope.errorFlag = true;
        });
    };

    $scope.cancel = function () {
        $uibModalInstance.close('cancel');
    };

    $scope.$on('$locationChangeStart', function (event, next, current) {
        $scope.close();
        event.preventDefault();
    });
}
